import React from "react";
import {
  Typography,
  Grid,
  useTheme,
  TextField,
  Button,
  IconButton,
  Tooltip,
  useMediaQuery,
} from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import PropTypes from "prop-types";
import BlockIcon from "@material-ui/icons/RotateLeft";

const DailogComponent = (props) => {
  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <div
      style={
        props.heading === "API Key" && isMatch !== true
          ? { width: "400px" }
          : { width: "300px" }
      }
    >
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        xs={12}
        md={12}
        lg={12}
        style={{
          textAlign: "center",
          margin: "auto",
        }}
      >
        <Grid
          xs={12}
          md={12}
          lg={12}
          container
          style={{ backgroundColor: "#3f51b5", height: "50x" }}
        >
          <Grid xs={12} md={12} lg={12} item>
            <IconButton
              style={{
                position: "absolute",
                marginLeft: "33%",
                marginTop: "3%",
                textAlign: "right",
              }}
              onClick={() => {
                props.setDailog(false);
              }}
            >
              <CancelIcon />
            </IconButton>
          </Grid>
          <Grid xs={12} md={12} lg={12} item style={{ margin: "auto" }}>
            <Typography
              style={{
                marginTop: "3vh",
                fontWeight: "bold",
                color: "#ffffff",
                fontSize: "19px",
                marginBottom: "2vh",
                textAlign: "center",
              }}
            >
              {props.heading}
            </Typography>
          </Grid>
        </Grid>
        {props.heading === "Account Settings" && (
          <>
            <Grid item xs={11} md={11} lg={11}>
              <Tooltip
                title={
                  props?.apiEndpoint ||
                  "Please enter the API endpoint provided by your service provider"
                }
              >
                <TextField
                  style={{ width: "90%" }}
                  maxRows={3}
                  minRows={3}
                  value={props.apiEndpoint}
                  name="apiEndpoint"
                  size="large"
                  margin="dense"
                  variant="outlined"
                  label={`Enter API Endpoint`}
                  onChange={props.handleChange}
                />
              </Tooltip>

              <Tooltip title={"Clear"}>
                <IconButton
                  onClick={props.handleEndpointClear}
                  style={{
                    marginLeft: "1px",
                    paddingTop: "17px",
                    paddingLeft: "0px",
                    paddingRight: "0px",
                  }}
                >
                  <BlockIcon />
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid item xs={11} md={11} lg={11}>
              <Tooltip
                title={
                  props?.data ||
                  "Please enter the account id provided by your service provider"
                }
              >
                <TextField
                  style={{ width: "90%", marginLeft: "-5.5%" }}
                  maxRows={3}
                  minRows={3}
                  defaultvalue={window?.config?.accountId}
                  value={props?.data}
                  name="account"
                  size="large"
                  margin="dense"
                  variant="outlined"
                  label={`Enter Account Id`}
                  onChange={props.handleChange}
                />
              </Tooltip>
            </Grid>
            <Grid item xs={11} md={11} lg={11}>
              <TextField
                style={{ width: "90%", marginLeft: "-5.5%" }}
                value={props.phonenumber}
                size="large"
                name="phonenumber"
                margin="dense"
                variant="outlined"
                label={`Enter Tenant Phone Number`}
                onChange={props?.handleChange}
              />
            </Grid>
            <Grid item xs={11} md={11} lg={11}>
              <TextField
                style={{ width: "90%", marginLeft: "-5.5%" }}
                multiline={props?.heading === "Account Settings" ? true : false}
                maxRows={3}
                minRows={3}
                value={props.apiKey}
                size="large"
                name="apiKey"
                margin="dense"
                variant="outlined"
                label={`Enter ${props?.PlaceholderName}`}
                onChange={props?.handleChange}
              />
            </Grid>
          </>
        )}
        {props.heading !== "Account Settings" && (
          <>
            {props.heading !== "Play" && (
              <Grid item xs={12} md={12} lg={12}>
                <TextField
                  style={{ width: "90%" }}
                  multiline={props.heading === "API Key" ? true : false}
                  maxRows={3}
                  minRows={3}
                  defaultvalue={window?.config?.accountId}
                  value={props.data}
                  size="large"
                  margin="dense"
                  variant="outlined"
                  label={`Enter ${props.PlaceholderName}`}
                  onChange={props.handleChange}
                  disabled={
                    props.heading === "Play" || props.heading === "Media Analysis"
                  }
                />
              </Grid>
            )}
            <Grid item xs={12} md={12} lg={12}>
              <TextField
                outlined
                style={
                  props.heading === "Play"
                    ? { width: "90%", marginTop: "8%" }
                    : { width: "90%" }
                }
                maxRows={3}
                minRows={3}
                value={props?.data1}
                size="large"
                margin="dense"
                variant="outlined"
                label={`Enter ${props.PlaceholderName2}`}
                // placeholder={`Enter ${props.PlaceholderName1}`}
                onChange={props?.handleChange1}
              />
            </Grid>
          </>
        )}
      </Grid>
      {/* {props.heading !== "Invite" ? ( */}
      <Grid
        xs={12}
        md={7}
        lg={7}
        item
        style={{
          marginBottom: "5vh",
          marginTop: "2vh",
          // marginLeft: "1.5vw",
          justifyContent: "center",
          textAlign: "center",
          margin: "auto",
        }}
      >
        <Button
          data-testid="button"
          onClick={props?.handleClick}
          disabled={
            props.ButtonName !== "Invite"
              ? props?.data?.length === 0 ||
                props?.data1?.length === 0 ||
                props?.phonenumber?.length === 0 ||
                props?.apiEndpoint?.length === 0
              : props?.data?.length === 0 || props?.data1?.length === 0
          }
          style={{
            //   background: state.identity === "" ? "lightgrey" : "#314B9F",
            width: "100px",
            height: "34px",
            justifyContent: "center",
            textAlign: "center",
            margin: "auto",
            marginTop: "3vh",
            marginBottom: "3vh",
          }}
          variant="contained"
          size="small"
          color="primary"
        >
          {props.ButtonName}
        </Button>
      </Grid>
    </div>
  );
};

DailogComponent.propTypes = {
  setDailog: PropTypes.any,
  handleClick: PropTypes.any,
  handleChange: PropTypes.any,
  PlaceholderName: PropTypes.string,
  ButtonName: PropTypes.string,
  heading: PropTypes.string,
  data: PropTypes.any,
  apiKey: PropTypes.any,
  PlaceholderName1: PropTypes.any,
  data1: PropTypes.any,
  handleChange1: PropTypes.any,
  PlaceholderName2: PropTypes.any,
  apiEndpoint: PropTypes.any,
  handleEndpointClear: PropTypes.any,
  inviteData: PropTypes.any,
  sip: PropTypes.any,
  setList: PropTypes.any,
  phonenumber: PropTypes.any,
};

export default DailogComponent;
